/**
 * @generated SignedSource<<5566aeb1765f994f09c9b0ce78801082>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type urlsFragment_image$data = {
  readonly climb: {
    readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_climb">;
  } | null;
  readonly gym: {
    readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_gym">;
  } | null;
  readonly id: string;
  readonly organization: {
    readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_organization">;
  } | null;
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_user">;
  };
  readonly wall: {
    readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_wall">;
  } | null;
  readonly " $fragmentType": "urlsFragment_image";
};
export type urlsFragment_image$key = {
  readonly " $data"?: urlsFragment_image$data;
  readonly " $fragmentSpreads": FragmentRefs<"urlsFragment_image">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "urlsFragment_image",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserType",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "urlsFragment_user"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationType",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "urlsFragment_organization"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GymType",
      "kind": "LinkedField",
      "name": "gym",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "urlsFragment_gym"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WallType",
      "kind": "LinkedField",
      "name": "wall",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "urlsFragment_wall"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClimbType",
      "kind": "LinkedField",
      "name": "climb",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "urlsFragment_climb"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ImageType",
  "abstractKey": null
};

(node as any).hash = "5630983b1299f38c771b4ad8690103da";

export default node;
